import { ModuleType } from 'modules/common/types';
import { pages } from './pages';

export const userMessagesModule: ModuleType = {
	pages,
};
